import { useIntl } from 'react-intl';
import { ButtonUI, Selector } from 'sonata-react-components';

import type { LocationFilterConfig } from './useLocationFilters';

type Props = {
  location: LocationFilterConfig;
};

function LocationFilterSection({ location }: Readonly<Props>) {
  const { formatMessage } = useIntl();
  const { countrySelector, hasActive, levels, onClear } = location;

  return (
    <div className="filters__location">
      {countrySelector && (
        <div className="filters__item">
          <span className="filters__label">{countrySelector.label}</span>
          <Selector
            id="filters-location-country"
            onChange={countrySelector.onChange}
            options={countrySelector.options}
            tiny
            type="simple"
            value={countrySelector.value}
          />
        </div>
      )}
      {levels.map(level => (
        <div className="filters__item" key={level.id}>
          <span className="filters__label">{level.label}</span>
          <Selector
            id={`filters-location-${level.id}`}
            onChange={level.onChange}
            options={level.options}
            tiny
            type="multiple"
            value={level.value}
          />
        </div>
      ))}
      <div className="filters__clearSection">
        <ButtonUI
          disabled={!hasActive}
          icon="fa-solid fa-trash"
          onClick={onClear}
          shape="link"
          size="ultraSmall"
          text={formatMessage({
            defaultMessage: 'Clear location',
            id: 'multiFlightListsMap.filters.clearLocation'
          })}
          type="secondary"
        />
      </div>
    </div>
  );
}

export default LocationFilterSection;
